import React from "react"
import PropTypes from "prop-types"
import commaNumber from "comma-number"
import StringHelper from "../../common/helpers/string_helper"
import {
  ROOM_TYPE,
  ratingClassification
} from "../../common/constants/classifications"
import AddressHelper from "../../common/helpers/address_helper"
import PhotoGallery from './photo_gallery'
import WeeklyDiscount from "../../common/components/listing_item/weekly_discount"
import PriceRange from "../../common/components/listing_item/price_range"
import "./listing_item.scss"
import { withNamespaces, Trans } from "react-i18next"
import { compose } from 'redux'
import CouponHelper from '../../common/helpers/coupon_helper'

class ListingItem extends React.Component {

  getListingPathById() {
    const { id, checkin, checkout, rooms, adults } = this.props
    return routeUrlHelper.listingPath(id, {
      checkin,
      checkout,
      rooms,
      adults
    })
  }

  getRoomTypeTranslation(roomType) {
    const { t } = this.props
    const transRoomTypes = {
      "丸ごと貸切": t('search.search_conditions.filter.room_type.entire'),
      "個室": t('search.search_conditions.filter.room_type.private')
    }

    return transRoomTypes[roomType]
  }

  renderDiscount() {
    const weeklyDiscount = this.props.basic_price_setting && this.props.basic_price_setting.weekly_discount
    return weeklyDiscount ? <WeeklyDiscount discountPercentage={weeklyDiscount} /> : null
  }

  renderSummary() {
    /* eslint-disable */
    const {
      property_type,
      room_title,
      is_instant_booking,
      title,
      lang,
      isSP,
      coupons,
      disinfection_measures_present: disinfectionMeasuresPresent,
      t
    } = this.props

    let instant = null
    if (is_instant_booking) {
      instant = (
        <span styleName="instant-booking-mark">
          <span
            className="vs-icon-lightning-bolt-fill"
            styleName="icon"
          />
          <span>{ t('search.listing_item.instant_booking') }</span>
        </span>
      )
    }

    return (
      <React.Fragment>
        <p styleName="property-type">{property_type}</p>
        <p itemProp="name" styleName="room-type-title">
          {isSP ?
            <span className="notranslate">{StringHelper.getPreferredLanguageString(room_title, lang)}</span> :
            <a className="notranslate" href={this.getListingPathById()} itemProp="mainEntityOfPage">
              {StringHelper.getPreferredLanguageString(room_title, lang)}
            </a>
          }
          {instant}
        </p>
        <p className="notranslate" styleName="property-title">
          {StringHelper.getPreferredLanguageString(title, lang)}
        </p>
        {(coupons && coupons.length) || disinfectionMeasuresPresent ? (
          <p styleName="tags">
            {coupons && coupons.map((coupon, index) => (
              <span key={index} styleName="coupon" className={`coupon-${coupon.id}`}>{ CouponHelper.translateName(coupon.title, this.props.lang, 'listing_item') }</span>
            ))}
            {disinfectionMeasuresPresent ? <span styleName="disinfection-measures">{ t('search.listing_item.coronavirus') }</span> : ''}
          </p>
        ) : null}
      </React.Fragment>
    )
    /* eslint-enable */
  }

  renderPrice() {
    const { min_price: minPrice, isSP, t } = this.props
    // TODO: const rakutenPoint = Math.floor(minPrice / 100)
    return (
      <div styleName="price-container">
        <div styleName="price-wrapper">
          <div styleName="price">
            <PriceRange
              checkin={this.props.checkin}
              checkout={this.props.checkout}
              min_price={this.props.min_price}
              max_price={this.props.max_price}
              accommodation_fee={this.props.accommodation_fee}
              t={this.props.t}
            />
          </div>
          {/* TODO: <p styleName="rakuten-super-point">
            <span styleName="label">楽天ポイント</span>
            <span styleName="point">{commaNumber(rakutenPoint)}〜</span>
          </p> */}
        </div>
        {!isSP &&
          <div styleName="btn-primary">
            <a href={this.getListingPathById()} target="_blank">{ t('search.listing_item.item_details') }</a>
          </div>
        }
      </div>
    )
  }

  renderRating() {
    const { review_stats: reviewStats, t } = this.props
    if (reviewStats) {
      const { overall_stats: { count, avg } } = reviewStats
      const averageRating = avg.toFixed(1)
      const cls = ratingClassification(averageRating)
        .toLowerCase().replace(/ /g, "-").replace(/[^\w-]/, "")
      return (
        <div
          styleName={`review-stats review-stats-${cls || "default"}`}
          itemProp="aggregateRating"
          itemScope
          itemType="http://schema.org/AggregateRating"
        >
          <meta itemProp="worstRating" content="1" />
          <div styleName="cols">
            <div styleName="rating">
              <div>
                <span styleName="rating-value" itemProp="ratingValue">
                  {averageRating}
                </span>
                <span styleName="best-rating" itemProp="bestRating">/5</span>
              </div>
            </div>
            <div styleName="summary">
              <div styleName="label">{ratingClassification(averageRating)}</div>
              <div styleName="count">
                <span itemProp="reviewCount" className="notranslate">
                  {count}
                </span>
                { t('search.listing_item.reviews', { count: count }) }
              </div>
            </div>
          </div>
        </div>
      )
    }
    return null
  }

  renderSpecs() {
    const {
      room_type: roomType,
      room_type_localized: roomTypeLocalized,
      maximum_guests: maximumGuests,
      is_shared_bath: isSharedBath,
      bedrooms,
      bathrooms,
      beds,
      size,
      t
    } = this.props

    const _roomType = roomType === ROOM_TYPE.PRIVATE_ROOM
      ? "vs-icon-private-room" : "vs-icon-entire-home"
    return (
      <ul styleName="room-spec-icon-list">
        <li>
          <span
            className={_roomType}
            styleName="icon"
          />
          <span styleName="label">{this.getRoomTypeTranslation(roomTypeLocalized)}</span>
        </li>
        <li>
          <span className="vs-icon-guests" styleName="icon" />
          <Trans i18nKey="search.listing_item.number_of_guest">
            <span styleName="label">
            定員
              <span className="notranslate">
                {{maximumGuests}}
              </span>
            名
            </span>
          </Trans>
        </li>
        <li>
          <span className="vs-icon-bedroom" styleName="icon" />
          <Trans i18nKey="search.listing_item.bedrooms">
            <span styleName="label">
            寝室
              <span className="notranslate">
                {{bedrooms}}
              </span>
            室
            </span>
          </Trans>
        </li>
        <li>
          <span className="vs-icon-bathroom" styleName="icon" />
          <span styleName="label">
            {isSharedBath ? t('search.listing_item.shared_bath') : ''}
            <Trans i18nKey="search.listing_item.bathrooms">
              浴室
              <span className="notranslate">{{bathrooms}}</span>
              室
            </Trans>
          </span>
        </li>
        <li>
          <span className="vs-icon-bed" styleName="icon" />
          <Trans i18nKey="search.listing_item.beds">
            <span styleName="label">
            寝具
              <span className="notranslate">
                {{beds}}
              </span>
            組
            </span>
          </Trans>
        </li>
        <li>
          { size > 1 &&
            <React.Fragment>
              <span className="vs-icon-size" styleName="icon" />
              <span styleName="label">
                { t('search.listing_item.size') }
                <span className="notranslate">
                  {size}&#x33a1;
                </span>
              </span>
            </React.Fragment>
          }
        </li>
      </ul>
    )
  }

  renderAddress() {
    /* eslint-disable */
    const {
      lang,
      prefecture,
      city,
      street_address,
      apt_name,
      distance,
      country_code,
      country,
      t
    } = this.props

    const fullAddressText = AddressHelper.address(
      prefecture, city, street_address, apt_name, lang, country_code, country
    )
    /* eslint-enable */
    let distanceFromDestination = null
    if (typeof distance == 'number') {
      var distance_value = (distance / 1000).toFixed(1) + "km"
      distanceFromDestination = (
        <span styleName="distance-from-destination">
          <span>
            <Trans i18nKey='search.listing_item.destination'>
              目的地から
              <span className="notranslate" styleName="distance-value">
                {{ distance: distance_value }}
              </span>
            </Trans>
          </span>
        </span>
      )
    }

    return (
      <div styleName="address">
        <span className="vs-icon-pin" styleName="icon" />
        <span itemProp="address">
          {fullAddressText}{distanceFromDestination}
        </span>
      </div>
    )
  }

  renderContent() {
    return (
      <React.Fragment>
        <div styleName="property-container">
          {this.renderSummary()}
          {this.renderRating()}
          <hr />
          {this.renderSpecs()}
          {this.renderAddress()}
          {this.renderDiscount()}
        </div>
        {this.renderPrice()}
      </React.Fragment>
    )
  }

  render() {
    const { id, checkin, checkout, adults, rooms, photos, photos_imgix: photosImgix, total_photos: totalPhotos, isSP, lang, isPromotion, t } = this.props
    return (
      <div
        id={isPromotion && id}
        key={id}
        styleName={`listing-card${isPromotion ? ' promotion' : ''}`}
        itemScope
        itemType="http://schema.org/LodgingBusiness"
        className={ isPromotion && 'ga-preferred' }
      >
        {isSP
          ? <a
            styleName="listing-summary"
            itemProp="mainEntityOfPage"
            href={this.getListingPathById()}
          >
            <div styleName="left-column">
              <PhotoGallery
                id={id}
                checkin={checkin}
                checkout={checkout}
                adults={adults}
                rooms={rooms}
                photos={photos}
                photos_imgix={photosImgix}
                totalPhotos={totalPhotos}
                isSP={isSP}
              />
            </div>
            <div styleName="right-column">
              {this.renderContent()}
            </div>
          </a>
          : <div
            styleName="listing-summary"
          >
            <div styleName="left-column">
              <PhotoGallery
                id={id}
                checkin={checkin}
                checkout={checkout}
                adults={adults}
                rooms={rooms}
                photos={photos}
                photos_imgix={photosImgix}
                totalPhotos={totalPhotos}
                isSP={isSP}
              />
            </div>
            <div
              styleName="right-column"
            >
              {this.renderContent()}
            </div>
          </div>
        }
        {isPromotion &&
          <div styleName="tag">{t('search.listing_item.promotion')}</div>
        }
      </div>
    )
  }
}

ListingItem.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.shape({
    ja: PropTypes.string,
    en: PropTypes.string,
    ko: PropTypes.string
  }).isRequired,
  prefecture: PropTypes.shape({
    ja: PropTypes.string,
    en: PropTypes.string,
    "zh-CN": PropTypes.string,
    "zh-TW": PropTypes.string,
    ko: PropTypes.string
  }).isRequired,
  city: PropTypes.shape({
    ja: PropTypes.string,
    auto_en: PropTypes.string,
    "auto_zh-CN": PropTypes.string,
    "auto_zh-TW": PropTypes.string,
    auto_ko: PropTypes.string
  }).isRequired,
  street_address: PropTypes.shape({
    ja: PropTypes.string.isRequired,
    auto_en: PropTypes.string,
    "auto_zh-CN": PropTypes.string,
    "auto_zh-TW": PropTypes.string,
    auto_ko: PropTypes.string
  }).isRequired,
  apt_name: PropTypes.shape({
    ja: PropTypes.string,
    auto_en: PropTypes.string,
    "auto_zh-CN": PropTypes.string,
    "auto_zh-TW": PropTypes.string,
    auto_ko: PropTypes.string
  }).isRequired,
  distance: PropTypes.number,
  property_type: PropTypes.oneOfType([
    PropTypes.string, PropTypes.array
  ]),
  zip_code: PropTypes.string.isRequired,
  review_stats: PropTypes.shape({
    overall_stats: PropTypes.shape({
      count: PropTypes.number,
      avg: PropTypes.number
    })
  }),
  checkin: PropTypes.string,
  checkout: PropTypes.string,
  adults: PropTypes.string,
  rooms: PropTypes.array,
  room_title: PropTypes.shape({
    ja: PropTypes.string,
    en: PropTypes.string,
    ko: PropTypes.string
  }),
  room_type: PropTypes.string.isRequired,
  room_type_localized: PropTypes.string.isRequired,
  min_price: PropTypes.number.isRequired,
  maximum_guests: PropTypes.number.isRequired,
  bedrooms: PropTypes.number.isRequired,
  is_instant_booking: PropTypes.bool.isRequired,
  is_shared_bath: PropTypes.bool.isRequired,
  bathrooms: PropTypes.number.isRequired,
  beds: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  lang: PropTypes.string.isRequired,
  destination: PropTypes.string,
  photos: PropTypes.array.isRequired,
  photos_imgix: PropTypes.array.isRequired,
  photos_large: PropTypes.array.isRequired,
  total_photos: PropTypes.number.isRequired
}

ListingItem.defaultProps = {
  adults: undefined,
  checkin: undefined,
  checkout: undefined,
  review_stats: null,
  destination: undefined
}

export default compose( withNamespaces('search') )(ListingItem)
